import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { formatDataTestId, formatDate, useSemanticTypography } from '@whitbread-eos/utils';
import { formatDistance } from 'date-fns';
import React from 'react';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmationDetails(_ref) {
  var data = _ref.data,
    t = _ref.t,
    currentLang = _ref.currentLang;
  var confirmationDetails = data.confirmationDetails;
  var baseDataTestId = 'BookingReferenceDetails';
  var getTypographyProps = useSemanticTypography();
  if (!confirmationDetails) {
    return _jsx(_Fragment, {});
  }
  var bookingReference = confirmationDetails.bookingReference,
    hotelName = confirmationDetails.hotelName,
    hotelAddress = confirmationDetails.hotelAddress,
    hotelTel = confirmationDetails.hotelTel,
    roomReservationStartDate = confirmationDetails.roomReservationStartDate,
    roomReservationEndDate = confirmationDetails.roomReservationEndDate,
    leadGuestTitle = confirmationDetails.leadGuestTitle,
    leadGuestName = confirmationDetails.leadGuestName,
    rateType = confirmationDetails.rateType,
    paymentOption = confirmationDetails.paymentOption;
  var getNrNights = () => {
    return parseInt(formatDistance(new Date(roomReservationStartDate), new Date(roomReservationEndDate)).replace(/^\D+/g, ''));
  };
  var getConfirmationBtnLabel = () => {
    switch (paymentOption) {
      case 'PAY_ON_ARRIVAL':
        return t('booking.confirmation.reservedWithCard');
      case 'PAY_NOW':
        return t('booking.confirmation.paymentTaken');
      case 'RESERVE_WITHOUT_CARD':
        return t('booking.confirmation.reservedWithoutCard');
      default:
        return '';
    }
  };
  return _jsxs(Box, _objectSpread(_objectSpread({}, contentWrapperStyle), {}, {
    children: [_jsx(Text, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'Label'),
      sx: {
        '@media print': {
          mt: 'md',
          fontSize: 'xxs'
        }
      }
    }, bookingRefLabelLayoutStyles), getTypographyProps(bookingRefLabelLegacyTypography, bookingRefLabelSemanticTypography)), {}, {
      children: t('booking.confirmation.bookingReference')
    })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'Id'),
      sx: {
        '@media print': {
          mt: '0',
          fontSize: 'xxs'
        }
      }
    }, bookingRefLayoutStyles), getTypographyProps(bookingRefLegacyTypography, bookingRefSemanticTypography)), {}, {
      children: bookingReference
    })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'Hotel')
    }, hotelNameLayoutStyles), getTypographyProps(hotelNameLegacyTypography, hotelNameSemanticTypography)), {}, {
      sx: {
        '@media print': {
          fontWeight: 'semibold'
        }
      },
      children: hotelName
    })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'HotelAdress')
    }, hotelAddressLayoutStyles), getTypographyProps(hotelAddressLegacyTypography, hotelAddressSemanticTypography)), {}, {
      sx: {
        '@media print': {
          fontWeight: 'semibold'
        }
      },
      children: hotelAddress
    })), _jsxs(Text, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": formatDataTestId(baseDataTestId, 'HotelPhone')
    }, bookingTelLayoutStyles), getTypographyProps(bookingTelLegacyTypography, bookingTelSemanticTypography)), {}, {
      sx: {
        '@media print': {
          mb: '0'
        }
      },
      children: [t('booking.confirmation.tel'), " ", hotelTel]
    })), _jsxs(Box, {
      display: "none",
      sx: {
        '@media print': {
          display: 'block',
          fontSize: 'md'
        }
      },
      children: [_jsxs(Text, {
        mb: "sm",
        children: [t('booking.hotel.summary.arriving'), ":", ' ', _jsx("strong", {
          children: formatDate(roomReservationStartDate, 'EEEE, d LLL yyyy', currentLang)
        }), ' ', t('booking.hotel.summary.after2pm')]
      }), _jsxs(Text, {
        mb: "sm",
        children: [t('booking.hotel.summary.checkout'), ":", ' ', _jsx("strong", {
          children: formatDate(roomReservationEndDate, 'EEEE, d LLL yyyy', currentLang)
        }), ' ', t('booking.confirmation.checkoutTime')]
      }), _jsxs(Text, {
        mb: "sm",
        children: [t('booking.summary.nights'), ": ", _jsx("strong", {
          children: getNrNights()
        })]
      }), _jsxs(Text, {
        mb: "sm",
        children: [t('booking.summary.rate'), " ", _jsx("strong", {
          children: rateType
        })]
      }), _jsxs(Text, {
        mb: "sm",
        className: "sessioncamhidetext assist-no-show",
        children: [t('booking.confirmation.bookedBy'), ":", ' ', _jsxs("strong", {
          children: [leadGuestTitle, " ", leadGuestName]
        })]
      }), _jsxs(Text, {
        mb: "md",
        children: [t('booking.management.bookingReview.paymentStatusTitle'), ":", ' ', _jsx("strong", {
          children: getConfirmationBtnLabel()
        })]
      })]
    })]
  }));
}
var contentWrapperStyle = {
  w: 'full'
};
var bookingRefLabelLayoutStyles = {
  mb: 'xs'
};
var bookingRefLabelLegacyTypography = {
  fontSize: 'lg',
  fontWeight: 'bold'
};
var bookingRefLabelSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var bookingRefLayoutStyles = {
  mb: 'lg'
};
var bookingRefLegacyTypography = {
  fontSize: '2xl'
};
var bookingRefSemanticTypography = {
  textStyle: 'body-l-regular'
};
var hotelNameLayoutStyles = {
  mb: 'xs'
};
var hotelNameLegacyTypography = {
  fontSize: '2xl',
  fontWeight: 'bold'
};
var hotelNameSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var hotelAddressLayoutStyles = {
  mb: 'xs'
};
var hotelAddressLegacyTypography = {
  fontSize: '2xl'
};
var hotelAddressSemanticTypography = {
  textStyle: 'body-l-regular'
};
var bookingTelLayoutStyles = {
  mb: '2xl'
};
var bookingTelLegacyTypography = {
  fontSize: 'md'
};
var bookingTelSemanticTypography = {
  textStyle: 'body-l-regular'
};